export default __webpack_public_path__ + "static/media/SAS Alert Tone 5.81cf5671.wav";